/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import cx from 'classnames';
import Hidden from '../Hidden';
import ContentContainer from '../AZCustomComponent/ContentContainer';
import type { FilterDataType, HandleFilterType } from '@/types/filterTypes';
import { FilterMobile as FilterMobileContain } from './FilterMobile';
import { FilterDesktop as FilterDesktopContain } from './FilterDesktop';
import styles from './styles.module.scss';
import { useMediaQuery } from '@/hooks/useMediaQuery';

type Props = {
  pageType: string;
  staticFilterData: Array<FilterDataType> | undefined | null;
  dynamicFilterData?: Array<FilterDataType> | null;
  queryDisplayLabel?: string;
  isVehicleAdded?: boolean;
  viewingPartTypes: boolean;
  onFilterSelect?: (filter: HandleFilterType) => void;
};

export const Filter = ({
  pageType,
  staticFilterData,
  dynamicFilterData,
  onFilterSelect,
  viewingPartTypes,
}: Props) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <ContentContainer
      id="search-page-filters"
      type="simple"
      className={cx({
        [styles.filterContainer]: isDesktop,
      })}
    >
      <Hidden lgUp mdDown={!staticFilterData?.length && !dynamicFilterData?.length}>
        <FilterMobileContain
          viewingPartTypes={viewingPartTypes}
          staticFilterData={staticFilterData}
          dynamicFilterData={dynamicFilterData}
          pageType={pageType}
          onFilterSelect={onFilterSelect}
        />
      </Hidden>
      <Hidden mdDown>
        <FilterDesktopContain
          staticFilterData={staticFilterData}
          dynamicFilterData={dynamicFilterData}
          pageType={pageType}
          onFilterSelect={onFilterSelect}
        />
      </Hidden>
    </ContentContainer>
  );
};
